import { render, staticRenderFns } from "./StockValue.vue?vue&type=template&id=3b39cc08"
import script from "./StockValue.vue?vue&type=script&lang=ts"
export * from "./StockValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports